<template>
  <div class="type-hangul">
    <div class="paper" ref="type">{{textData}}</div>
    <span v-if="cursor" class="cursor" :class="{typing}"></span>
  </div>
</template>

<script>
import TypeHangul from '.';

export default {
  name: 'TypeHangul',
  data() {
    return {
      typing: false,
      typeText: '',
      currentText: 0,
      typeList: [],
    };
  },
  props: {
    textData: {
      type: String,
      require: true,
    },
    backspace: {
      type: Boolean,
      default: false,
    },
    cursor: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    textData() {
      TypeHangul.type('.paper', { text: this.textData, humanize: 0.5 });
    },
  },
  mounted() {
    this.typeText = typeof this.textData === 'string' ? this.textData : this.textData[this.currentText];
    const { type } = this.$refs;
    type.addEventListener('th.startType', () => {
      this.typing = true;
    });
    TypeHangul.type('.paper', { text: this.typeText, humanize: 0.5 });
    type.addEventListener('th.afterType', (e) => {
      this.typeList.unshift(e.detail.progress);
    });
    type.addEventListener('th.endType', () => {
      if (this.backspace) {
        this.doBackspace();
      } else {
        this.typing = false;
        this.$emit('typeend', type);
      }
    });
  },
  destroyed() {
  },
  methods: {
    doBackspace() {
      let cnt = 0;
      const { length } = this.typeList;
      const { type } = this.$refs;
      const bs = setInterval(() => {
        if (cnt > length) {
          clearInterval(bs);
          this.typeList = [];
          this.$emit('typeend', type);
          this.typing = false;
        } else if (!type) {
          clearInterval(bs);
        } else {
          type.textContent = this.typeList[cnt] || [];
          cnt += 1;
        }
      }, 100);
    },
  },
};

</script>

<style lang="scss" scoped>
@keyframes cursor {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.type-hangul {
  position: relative;
  min-height: 200px;
}
.paper{
  position: relative;
  display: inline;
  height: 100%;
}
.cursor {
  position: absolute;
  display: inline-block;
  margin: 10px 20px;
  top: 20px;
  width: 5px;
  height: 1em;
  background-color: #0A0A0A;
  animation: cursor 250ms infinite alternate;
  &.typing {
    animation: none;
  }
}

</style>
